import type { AppLocale } from "@/config/app-locale";
import type { TenantCode, TenantIdentity } from "@/config/tenants";

interface TenantFooterAttribution {
  readonly owner: string;
  readonly poweredBy?: string;
}

export interface ResolvedTenantFooter {
  readonly copyright: string;
  readonly cookiePolicy: string;
  readonly privacyPolicy: string;
  readonly refundPolicy: string;
  readonly termsOfService: string;
}

const tenantFooterAttributions: Partial<Record<TenantCode, TenantFooterAttribution>> = {
  "12sc": {
    owner: "12sc",
  },
};

const legalCopy = {
  en: {
    allRightsReserved: "All rights reserved.",
    cookiePolicy: "Cookie Policy",
    poweredBy: "Powered by",
    privacyPolicy: "Privacy Policy",
    refundPolicy: "Refund Policy",
    termsOfService: "Terms of Service",
  },
  fr: {
    allRightsReserved: "Tous droits réservés.",
    cookiePolicy: "Politique relative aux cookies",
    poweredBy: "Propulsé par",
    privacyPolicy: "Politique de confidentialité",
    refundPolicy: "Politique de remboursement",
    termsOfService: "Conditions d’utilisation",
  },
} as const satisfies Record<AppLocale, Record<string, string>>;

export function resolveTenantFooter(tenant: TenantIdentity, locale: AppLocale, year: number): ResolvedTenantFooter {
  const attribution = tenantFooterAttributions[tenant.code] ?? { owner: tenant.displayName };
  const copy = legalCopy[locale];
  const poweredBy = attribution.poweredBy ? ` ${copy.poweredBy} ${attribution.poweredBy}` : "";

  return {
    copyright: `© ${year} ${attribution.owner}. ${copy.allRightsReserved}${poweredBy}`,
    cookiePolicy: copy.cookiePolicy,
    privacyPolicy: copy.privacyPolicy,
    refundPolicy: copy.refundPolicy,
    termsOfService: copy.termsOfService,
  };
}
